import React, { useState, useEffect } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Button,
  TablePagination,
  Stack,
  FormControl,
  Autocomplete,
  TextField,
  Grid,
  Box,
} from "@mui/material";
import { Link, useNavigate } from "react-router-dom";
import DeleteIcon from "@mui/icons-material/Delete";
import { toast } from "react-toastify";
import {
  ApiGenerateLoginToken,
  ApiGetClients,
  ApiPutDeleteClient,
} from "../../../apiService/Core/Apicall.tsx";
import { useSelector } from "react-redux";
import { RootState } from "../../../global/config/store.ts";
import useDebounce from "../CreateAllocations/UseDebounce.tsx";
import { setSelectedClientGroup } from "../../../global/config/Reducer/clientSlice.ts";
import { useDispatch } from "react-redux";

const ManageAdmin: React.FC = () => {
  const selectedClientName = useSelector((state: RootState) => state.client.selectedClient)
  const dispatch = useDispatch()
  const navigate = useNavigate();
  const [clients, setClients] = useState<any>([]);
  const [datalength, setdatalength] = useState<any>(null);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(50);
  const Clientlist = useSelector((state: RootState) => state.client.clientList);
  const [selectedClient, setSelectedClient] = useState<any>(selectedClientName);
  const [ClientId, setClientId] = useState(null);
  const [searchEntityName, setSearchEntityName] = useState("");
  const debouncedSearch = useDebounce(searchEntityName, 500);
  const adminId: any = localStorage.getItem('userId')

  useEffect(() => {
    if (Clientlist.length > 2) {
      // setSelectedClient(Clientlist[2]);
      setClientId(Clientlist[2].clientGroupName);

    }
  }, [Clientlist]);

  const addOrUpdateClient = (id?: any) => {
    if (id?.ClientID) {
      
      navigate(`/admin/clients-update/update/${id?.ClientID}`, {
        state: { clients: id },
      });
    } else {
      navigate("/admin/clients-update/add");
    }
  };
  useEffect(() => {
    const fetchData = async () => {
      await handleGetApiCall();
    };
    fetchData();
    return () => { };
  }, [page, rowsPerPage, selectedClient, debouncedSearch]);

  const handleGetApiCall = async () => {
    const data = `?offset=${rowsPerPage * page}&limit=${rowsPerPage}&status=active${selectedClient ? `&clientGroup=${selectedClient.clientGroupName}` : ''}${debouncedSearch ? `&searchTerm=${debouncedSearch}` : ""}`;
    try {
      const response: any = await ApiGetClients(data);
      setdatalength(response.totalDataCount)
      setClients(response.data);
    } catch (error) {
      console.error("Error during API call:", error);
    }
  };
  const deleteClient = async (user: any, newStatus: string) => {
    const data = `?clientId=${user?.ClientID}`;
    try {
      const response: any = await ApiPutDeleteClient(data);
      toast.success("Client Deleted successfully!");
      handleGetApiCall();
    } catch (error) {
      console.error("Error during API call:", error);
    }
  };
  // ------------------------------------------- Chnage Pagination -----------------------------------------------
  const handleChangePage = (_event: unknown, newPage: number) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };
  ;

  const getClientSiteURL = (hostname) => {
    switch (hostname) {
      case "ALDI":
        return process.env.REACT_APP_ALDI_CLIENT_SITE;
      case "BLOOMS":
        return process.env.REACT_APP_BLOOMS_CLIENT_SITE;
      case "MM":
      case "TRANSPORT": // same URL for both
        return process.env.REACT_APP_MM_CLIENT_SITE;
      default:
        return process.env.REACT_APP_MM_CLIENT_SITE;
    }
  }
  const navigateToLoginShopper = async (user) => {

    try {
      const data = {
        adminUserId: adminId,
        targetUserId: user.userId,
        ipAddress: '127.0.0.1',
        browserName: 'Google chrome'

      }
      const res = await ApiGenerateLoginToken(data)
      if (res.success) {
        window.open(`${getClientSiteURL(user.ClientGroupName.clientGroupName)}?adminuserid=${adminId}&validation=${res.data.token}`, '_blank');
      }
    } catch (error) {
      toast.error(error)
    }

  }

  useEffect(() => {
    setSelectedClient(selectedClientName)
  }, [selectedClientName])

  return (
    <Box className="w-100 p-2 px-2">
      <Grid alignItems={'center'} container className='w-100 mt-0 mb-4 my-md-5' gap={{ xs: 3, md: 0 }}>
        <Grid size={{ xs: 12, md: 4 }} order={{ xs: 3, md: 1 }}>
          <Stack flexWrap={'wrap'} direction="row" gap={{ xs: 2, md: 2 }} spacing={2}>
            <FormControl size="small" className="col-md-4 col-12" sx={{ width: 180 }}>
              <Autocomplete
                disablePortal
                id="mm-autocomplete"

                options={Clientlist}
                value={selectedClient}
                getOptionLabel={(option) => option?.clientGroupName}
                isOptionEqualToValue={(option, value) =>
                  option.clientGroupDBName === value.clientGroupDBName
                }
                onChange={(event, newValue: any) => {
                  // setSelectedClient(newValue);
                  dispatch(setSelectedClientGroup(newValue))
                  setClientId(newValue?.clientGroupName || null);
                }}

                renderInput={(params) => (
                  <TextField {...params} label="Select Client" />
                )}
                size="small"
              />
            </FormControl>
            <FormControl size="small" className="col-md-6 col-12 ml-0" sx={{ width: 250 }}>
              <TextField
                label="Search Client"
                size="small"
                value={searchEntityName}
                onChange={(e) => setSearchEntityName(e.target.value)}
              />
            </FormControl>
          </Stack>
        </Grid>
        <Grid size={{ xs: 12, md: 4 }} order={{ xs: 2, md: 2 }}>
          <h1 className="text-center pl-4">Manage Clients</h1>
        </Grid>
        <Grid size={{ xs: 12, md: 4 }} order={{ xs: 1, md: 3 }}>
          <Box className="d-flex justify-content-end">
            <Link
              to={'/admin/clients-update/add'}
              // variant="contained"

              // onClick={() => addOrUpdateClient()}
              className="table-row-background  link-btn"
            >
              Add New Clients
            </Link>
          </Box>
        </Grid>
      </Grid>
      <Box className='w-100' overflow={'auto'}>
        <Table  >
          <TableHead>
            <TableRow className="table-row-background">
              {[
                "Client Code",
                "Client Name",
                "Owner Name",
                "Owner Email ID",
                "",
                "Login",
                "",
                "",
              ].map((item) => (
                <TableCell className="fs-14" style={{ color: "#fff" }}>{item}</TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {clients.map((user) => (
              <TableRow key={user.id}>
                <TableCell className="fs-14">{user.ClientCode}</TableCell>
                <TableCell className="fs-14">{user.ClientName}</TableCell>
                <TableCell className="fs-14">{user.OwnerName}</TableCell>
                <TableCell className="fs-14">{user.OwnerEmailID}</TableCell>
                <TableCell className="fs-14">
                  <Link
                    to={`/admin/clients-update/update/${user?.ClientID}`}
                    // onClick={()=>{
                    //   localStorage.setItem("UpdateClients",JSON.stringify(user))
                    //   // navigate()
                    // }}
                    // variant="contained"
                    // onClick={() => addOrUpdateClient()}
                    className="table-row-background  link-btn"
                  >
                    Edit
                  </Link>
                  {/* <Button
                    variant="contained"
                    onClick={() => addOrUpdateClient(user)}
                    className="table-row-background fs-14"
                  >
                    Edit
                  </Button> */}
                </TableCell>
                <TableCell>
                  <Button
                    variant="contained"
                    onClick={() => navigateToLoginShopper(user)}
                    className="table-row-background fs-14"
                  >
                    Login
                  </Button>
                </TableCell>
                <TableCell>
                  <Link
                    // variant="contained"
                    to={`/admin/manage-clients/user/${user?.ClientID}`}
                    // state={{ clientId: user }}
                    // onClick={() => navigate("/admin/manage-clients/user", { state: { clientId: user } })}
                    className="link-btn table-row-background fs-14"
                  >
                    User
                  </Link>
                </TableCell>
                <TableCell>
                  <Button
                    variant="contained"
                    className="delete-transparent"
                    onClick={() => {
                      const isConfirmed = window.confirm(
                        "Are you sure you want to delete the client?"
                      );
                      if (isConfirmed) {
                        deleteClient(user, "delete"); // Call the API or action
                      }
                    }}
                  >
                    <DeleteIcon className="delete-icon" />
                  </Button>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </Box>
      <TablePagination
        rowsPerPageOptions={[5, 10, 25, 50]}
        component="div"
        count={datalength}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />
    </Box>
  );
};

export default ManageAdmin;
